import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoSchedeClinicheStep2Component
} from './conservazione-carica-documento-schede-cliniche-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-schede-cliniche-step2', {
            url: '/conservazione-carica-schede-cliniche',
            ncyBreadcrumb: {
                label: 'Carica Schede Cliniche',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-schede-cliniche-step2 flex="100"></conservazione-carica-documento-schede-cliniche-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoSchedeClinicheStep2Module: string = ng
    .module('conservazione-carica-documento-schede-cliniche-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoSchedeClinicheStep2', ConservazioneCaricaDocumentoSchedeClinicheStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-schede-cliniche-step2/conservazione-carica-documento-schede-cliniche-step2.module.ts